import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgCheckBadgeGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M24.1 40h-.2C15.13 40 8 32.87 8 24.09V8.75c0-.41.34-.75.75-.75h30.5c.41 0 .75.34.75.75s-.34.75-.75.75H9.5v14.59c0 7.94 6.46 14.41 14.4 14.41h.19c7.94 0 14.4-6.46 14.4-14.41V11.92a.755.755 0 0 1 1.51 0V24.1C40 32.87 32.87 40 24.1 40Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M22.86 30.94c-.35 0-.66-.25-.73-.6-.04-.17-.92-4.29-4.9-5.11a.74.74 0 0 1-.58-.89.74.74 0 0 1 .89-.58c2.67.56 4.21 2.27 5.07 3.77.82-3.23 2.91-8.68 8.07-11.63a.74.74 0 0 1 1.02.28c.2.36.07.82-.29 1.02-6.8 3.88-7.8 12.97-7.81 13.06a.75.75 0 0 1-.71.67c-.01.01-.02.01-.03.01Z",
    fill: "currentColor"
  }));
}

export { SvgCheckBadgeGlyphSecondary as default };
